import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'
import { IoRadioButtonOffSharp, IoRadioButtonOn } from 'react-icons/io5'

const VariantsSection = ({
  data,
  getUpdatedProduct,
  selectedOptions,
  setSelectedOptions,
  setSelectedSku,
  setVisibleSections,
  selectedSku,
  visibleSections,
  toggleSectionVisibility,
}: any) => {
  const { t } = useTranslation()
  const [outOfStockSkus, setOutOfStockSkus] = useState({})
  const [pdpConfig, setPdpConfig] = useState({
    configAttributes: data?.configAttributes,
    index: data?.index,
    optionSkus: data?.optionSkus,
  })

  useEffect(() => {
    if (data?.options) {
      Object?.entries(data?.options).map(([attr, val], index) => {
        updateSelection(attr, val)
      })
    } else {
      if (pdpConfig?.index && Object.keys(pdpConfig.index).length > 0) {
        const firstSku = Object.keys(pdpConfig.index)[0]
        if (firstSku) {
          setSelectedOptions({ ...pdpConfig.index[firstSku] })
          setSelectedSku(firstSku)
        }
      } else {
        console.warn('pdpConfig.index is undefined or empty:', pdpConfig?.index)
      }
    }
  }, [])

  useEffect(() => {
    const call = async () => {
      const updatedOutOfStockSkus = { outOfStockSkus }
      getUpdatedProduct(pdpConfig?.optionSkus?.[selectedSku])
    }
    if (selectedSku) {
      call()
    }
  }, [selectedSku])

  useEffect(() => {
    const updatedOutOfStockSkus = { outOfStockSkus }
    if (data && selectedSku && selectedOptions) {
      if (!data?.is_in_stock) {
        updatedOutOfStockSkus[selectedSku] = true
      } else {
        delete updatedOutOfStockSkus[selectedSku]
      }

      setOutOfStockSkus(updatedOutOfStockSkus)
      refreshOptionsStates(selectedOptions, updatedOutOfStockSkus)
    }
  }, [data, selectedOptions, selectedSku])

  const updateSelection = async (attributeId, value) => {
    const newSelection = { ...selectedOptions, [attributeId]: value }
    // Check if the selected option leads to a valid SKU
    const compatibleSku = Object.keys(pdpConfig.index).find((productId) =>
      Object.entries(newSelection).every(
        ([attr, val]) => pdpConfig.index[productId][attr] === val,
      ),
    )

    if (compatibleSku) {
      // Valid selection found
      window.scrollTo({ top: 0, behavior: 'smooth' })
      const updatedSelections = { ...pdpConfig.index[compatibleSku] }
      setSelectedOptions(updatedSelections)
      setSelectedSku(compatibleSku)
    } else {
      // If clicked option is invalid, search for the closest valid combination
      handleDisabledOption(attributeId, value)
    }
  }

  const handleDisabledOption = (attributeId, value) => {
    const alternativeSku = Object.keys(pdpConfig.index).find(
      (productId) => pdpConfig.index[productId][attributeId] === value,
    )
    if (alternativeSku) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      const alternativeSelections = { ...pdpConfig.index[alternativeSku] }
      setSelectedOptions(alternativeSelections)
      setSelectedSku(alternativeSku)
    }
  }

  const refreshOptionsStates = (currentSelections, outOfStockSkusState) => {
    const updatedAttributes = Object.keys(pdpConfig?.configAttributes).reduce(
      (acc, attrId) => {
        const optionsWithStates = pdpConfig.configAttributes[
          attrId
        ].options.map((option) => {
          const testSelection = { ...currentSelections, [attrId]: option.id }
          const isValid = Object.keys(pdpConfig.index).some((productId) =>
            Object.entries(testSelection).every(
              ([attr, val]) => pdpConfig.index[productId][attr] === val,
            ),
          )
          // Check if the SKU is out of stock
          const matchingSku = Object.keys(pdpConfig.index).find((productId) =>
            Object.entries(testSelection).every(
              ([attr, val]) => pdpConfig.index[productId][attr] === val,
            ),
          )
          const isOutOfStock = matchingSku && outOfStockSkusState[matchingSku]
          return {
            ...option,
            disabled: !isValid,
            outOfStock: !!isOutOfStock,
          }
        })
        acc[attrId] = {
          ...pdpConfig.configAttributes[attrId],
          options: optionsWithStates,
        }
        return acc
      },
      {},
    )
    setPdpConfig((prev) => ({ ...prev, configAttributes: updatedAttributes }))
  }
  return (
    <div className="mt-3">
      {Object.values(pdpConfig?.configAttributes || {}).map((attr: any) => {
        return (
          <div key={attr.id} className="border mb-5">
            <div
              onClick={() => toggleSectionVisibility(attr.id)}
              className="flex items-center justify-between bg-brand-bggray p-4 cursor-pointer "
            >
              <span className="font-semibold text-brand">{attr.label}</span>
              <span className="text-sm text-brand">
                (
                {attr.options?.find(
                  (option) => option.id === selectedOptions[attr.id],
                )?.label || t('select_option')}{' '}
                {'Selected'})
                <IoIosArrowDown
                  className={`text-brand-darkblue inline-flex ml-2 ${
                    !visibleSections ? 'rotate-180 ' : ''
                  } `}
                  fontSize={22}
                />
              </span>
            </div>
            {visibleSections[attr.id] && (
              <ul>
                {attr.options
                  ?.filter(
                    (option) => option.vendorid && option.vendorid !== '0',
                  )
                  .map((option) => (
                    <li
                      key={option.id}
                      className={`flex cursor-pointer items-center text-sm px-3 py-1.5 text-brand mb-1 
          ${
            selectedOptions[attr.id] === option.id ? 'bg-brand text-white' : ''
          } 
          ${option.disabled ? 'bg-brand-alphagray' : ''}
          ${option.outOfStock && 'line-through text-gray-400'}
          `}
                      onClick={() =>
                        option.disabled
                          ? handleDisabledOption(attr.id, option.id)
                          : updateSelection(attr.id, option.id)
                      }
                    >
                      {selectedOptions[attr.id] === option.id ? (
                        <IoRadioButtonOn className="text-white mr-2 text-lg" />
                      ) : (
                        <IoRadioButtonOffSharp className="text-brand mr-2 text-lg" />
                      )}
                      {option.label}
                    </li>
                  ))}
              </ul>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default VariantsSection
